export const selectDates = {

   namespaced: true,

   state: {
      options: {
         leaseModality: 'onDemand', // onDemand (locação por dia ou hora) ou signature (locação por assinatura)
         typeOfLeasePeriod: 'daily', // monthly (mês), perWeek (por semana), daily (por dia) ou perHour (por hora)
         numberOfMonthsOfLease: 1, // Número de meses, para locação assinatura por mês
         numberOfRentalWeeks: 1, // Número de semandas, para locação assinatura por semana
         daySelectedForHourlyRental: '', // Dia da pedalada, para pedalada por hora,
         startHourRental: '', // Hora inicial, para pedalada por hora
         endHourRental: '' // Hira final, para pedalada por hora
      },
      dates: '', // Range de datas, para pedalada por dia sob-demanda.
   },

   actions: {
      setDates({commit}, dates) {
         commit('updateDates', dates);
      },
      setLeaseModality({commit}, payload) {
         commit('updateLeaseModality', payload)
      },
      setTypeOfLeasePeriod({commit}, payload) {
         commit('updateTypeOfLeasePeriod', payload)
      },
      setNumberOfMonthsOfLease({commit}, payload) {
         commit('updateNumberOfMonthsOfLease', payload)
      },
      setNumberOfRentalWeeks({commit}, payload) {
         commit('updateNumberOfRentalWeeks', payload)
      },
      setDaySelectedForHourlyRental({commit}, payload) {
         commit('updateDaySelectedForHourlyRental', payload)
      },
      setStartHourRental({commit}, payload) {
         commit('updateStartHourRental', payload)
      },
      setEndHourRental({commit}, payload) {
         commit('updateEndHourRental', payload)
      },
      clearDates({commit}) {
         commit('updateDates', '')
      }
   },

   mutations: {
      updateDates(state, dates) {
         state.dates = dates
      },
      updateLeaseModality(state, payload) {
         state.options.leaseModality = payload
      },
      updateTypeOfLeasePeriod(state, payload) {
         state.options.typeOfLeasePeriod = payload
      },
      updateNumberOfMonthsOfLease(state, payload) {
         state.options.numberOfMonthsOfLease = payload
      },
      updateNumberOfRentalWeeks(state, payload) {
         state.options.numberOfRentalWeeks = payload
      },
      updateDaySelectedForHourlyRental(state, payload) {
         state.options.daySelectedForHourlyRental = payload
      },
      updateStartHourRental(state, payload) {
         state.options.startHourRental = payload
      },
      updateEndHourRental(state, payload) {
         state.options.endHourRental = payload
      }
   }
};
